import { useState } from "react";
import { X } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/data/landingData";

const whatsappMessage = encodeURIComponent("Bonjour, je souhaite obtenir une simulation pour mon enseigne.");
const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMessage}`;

export function WhatsAppWidget() {
  const [showChat, setShowChat] = useState(false);

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-50 flex flex-col items-end gap-3">
      {showChat && (
        <div className="bg-white rounded-2xl shadow-2xl p-4 w-72 animate-fade-in-up" data-testid="chat-bubble">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center">
                <WhatsAppIcon className="w-6 h-6 fill-white" />
              </div>
              <div>
                <p className="font-bold text-gray-900 text-sm">PUB PRO</p>
                <p className="text-xs text-green-600">En ligne</p>
              </div>
            </div>
            <button onClick={() => setShowChat(false)} className="text-gray-400 hover:text-gray-600">
              <X className="w-5 h-5" />
            </button>
          </div>
          
          <div className="bg-gray-100 rounded-xl p-3 mb-3">
            <p className="text-sm text-gray-700">Bonjour ! Comment puis-je vous aider ?</p>
            <p className="text-xs text-gray-500 mt-1">Réponse en moins de 5 minutes</p>
          </div>
          
          <div className="space-y-2">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => { if (window.gtag) { window.gtag('event', 'conversion', { send_to: 'AW-9775626347/click_whatsapp' }); } }}
              className="block w-full bg-[#25D366] text-white text-center py-2 rounded-lg font-medium text-sm hover:bg-[#20bd5a] transition-colors"
            >
              Démarrer la conversation
            </a>
            <a
              href="tel:+33643693688"
              onClick={() => { if (window.gtag) { window.gtag('event', 'conversion', { send_to: 'AW-9775626347/click_appel' }); } }}
              className="block w-full bg-gray-200 text-gray-700 text-center py-2 rounded-lg font-medium text-sm hover:bg-gray-300 transition-colors"
            >
              Appeler directement
            </a>
          </div>
        </div>
      )}
      
      <button
        onClick={() => setShowChat(!showChat)}
        className="bg-[#25D366] hover:bg-[#20bd5a] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(37,211,102,0.5)] flex items-center gap-2 group"
        data-testid="whatsapp-button"
      >
        {showChat ? (
          <X className="w-7 h-7" />
        ) : (
          <>
            <WhatsAppIcon className="w-7 h-7 fill-current" />
            <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 ease-in-out whitespace-nowrap font-semibold">
              Discutons !
            </span>
          </>
        )}
      </button>
      
      {!showChat && (
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
          <span className="text-white text-xs font-bold">1</span>
        </div>
      )}
    </div>
  );
}

function WhatsAppIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}
